<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Gdybym mógł, rozpętałbym rewolucję”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-kanapowi-buntownicy.jpg')"
             alt="group thumbnail"
             class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-kanapowi-buntownicy.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Dobrze wiesz, czego chcesz od życia.
          Nie lubisz ryzyka, bo nie zawsze się ono opłaca, chciałbyś zmian,
          ale w&nbsp;kontrolowanych warunkach.
        </p>
        <p>
          Cenisz sobie bezpieczeństwo i&nbsp;przewidywalność bliskiej
          i&nbsp;dalekiej przyszłości.<br/>
          Twój dom to Twój azyl – tutaj możesz żyć na swoich warunkach,
          nie musisz dostosowywać się do innych, nikt nie będzie Ci mówił, co masz robić.
        </p>
        <p>
          Często widzisz z&nbsp;boku rozwiązania, których inni nie dostrzegają
          i&nbsp;nie wprowadzają w&nbsp;życie.
          Potrafisz sobie doskonale wyobrazić, jak zagospodarować ewentualną wygraną w&nbsp;lotto.
        </p>
        <p>
          Polityka Cię męczy i&nbsp;denerwuje, uważasz, że nawet pójście na wybory
          niewiele może zmienić.
          Uważasz, że im dalej Państwo od Ciebie, tym lepiej.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KanapowiBuntownicy',
};
</script>

<style scoped>
.intro {
  color: #FFFFFF;
  background: var(--color-kanapowi-buntownicy);
  font-size: 1.3em;
  font-weight: 700;
  padding: .6em .8em;
}
</style>
